import { showTooltip, hideTooltip } from '../components/tooltips/tooltipState.js';

function parseValue(value) {
    if (value == null || value === false) return null;
    if (typeof value === 'string') return { content: value };
    if (typeof value === 'object') return value;
    return { content: String(value) };
}

function attach(el) {
    const enter = () => {
        const opts = el.__tt?.opts;
        if (!opts) return;
        showTooltip({ triggerEl: el, ...opts });
    };
    const leave = () => hideTooltip(el);

    el.addEventListener('mouseenter', enter);
    el.addEventListener('mouseleave', leave);
    el.addEventListener('focusin', enter);
    el.addEventListener('focusout', leave);

    return { enter, leave };
}

function detach(el) {
    const handlers = el.__tt;
    if (!handlers) return;
    el.removeEventListener('mouseenter', handlers.enter);
    el.removeEventListener('mouseleave', handlers.leave);
    el.removeEventListener('focusin', handlers.enter);
    el.removeEventListener('focusout', handlers.leave);
    hideTooltip(el);
    delete el.__tt;
}

export default {
    mounted(el, binding) {
        const opts = parseValue(binding.value);
        if (!opts) return;
        const { enter, leave } = attach(el);
        el.__tt = { opts, enter, leave };
    },
    updated(el, binding) {
        const opts = parseValue(binding.value);

        if (!opts) {
            detach(el);
            return;
        }

        if (!el.__tt) {
            const { enter, leave } = attach(el);
            el.__tt = { opts, enter, leave };
            return;
        }

        el.__tt.opts = opts;
    },
    unmounted(el) {
        detach(el);
    },
};
